import { createReducer, Reducer } from "@reduxjs/toolkit";
import { CartActions } from "./actions";

export namespace Cart {
  // export const allFraudReports: RemoteResource<
  //   AppStore,
  //   CartDTO.Responses.GetAllFraudReport.T,
  //   CartDTO.Responses.GetAllFraudReport.T,
  //   Pageable.T<keyof CartDTO.Responses.GetSingleFraudReport.T>
  // > = {
  //   fetch: CartActions.setAllFraudReportPagination,
  //   updateStore: CartActions.setAllFraudReport,
  //   selector: (store) => store.crypto.allFraudReport.data,
  // };
}

/**
 * Interface used for Redux Store
 */
export interface Cart {
  detailed: {
    verification: {
      individual: {
        kyc: number;
        aml: number;
      };
      business: {
        kyb: number;
        aml: number;
      };
    };
    participations: {
      users: number;
    };
  };
}

const initialState: Cart = {
  detailed: {
    participations: {
      users: 0,
    },
    verification: {
      business: { aml: 0, kyb: 0 },
      individual: { aml: 0, kyc: 0 },
    },
  },
};

// Reducer
export const cartReducer: Reducer<Cart, CartActions.Actions> = createReducer(
  initialState,
  (builder) => {
    builder.addCase(
      CartActions.Verification.updateKYC,
      (state, { payload }) => {
        state.detailed.verification.individual.kyc = payload;
      }
    );
    builder.addCase(
      CartActions.Verification.updateKYB,
      (state, { payload }) => {
        state.detailed.verification.business.kyb = payload;
      }
    );
    builder.addCase(
      CartActions.Verification.updateIndividualAML,
      (state, { payload }) => {
        state.detailed.verification.individual.aml = payload;
      }
    );
    builder.addCase(
      CartActions.Verification.updateBusinessAML,
      (state, { payload }) => {
        state.detailed.verification.business.aml = payload;
      }
    );
    builder.addCase(
      CartActions.Participations.updateUser,
      (state, { payload }) => {
        state.detailed.participations.users = payload;
      }
    );
  }
);
